import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useAppSelector } from '@redux/hooks';
import { Link } from '@tkww/orion-web-ds-action';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { useCallback } from 'react';
import type { Decorated } from 'types/vendor';
import VendorAnalytics from '../../../../../../decorators/vendorAnalytics';

import Styles from './styles.scss';

interface RelatedSearchProps {
	headline?: string;
}

export const RelatedSearches = ({ headline }: RelatedSearchProps) => {
	const cityUrl = useAppSelector(
		(state) => state.vendor.vendor?.breadcrumbInfo?.cityUrl,
	);
	const categoryName = useAppSelector((state) => state.category.name);
	const searchPageLocation = useAppSelector(
		(state) => state.searchPageLocation,
	);
	const vendor = useAppSelector((state) => state.vendor.vendor as Decorated);
	const { city, stateCode } = searchPageLocation;
	const text =
		headline ||
		`Explore other ${categoryName.toLowerCase()} in ${city} ${stateCode}`;
	const { track } = useAnalyticsContext();

	const onClickHandler = useCallback(() => {
		const vendorAnalytics = new VendorAnalytics(vendor);

		track({
			event: 'Explore Other Vendor Clicked',
			properties: {
				...vendorAnalytics.baseEventProps(),
				storefrontSection: 'About Vendor',
			},
		});
	}, [track, vendor]);

	if (!cityUrl) {
		return null;
	}

	return (
		<div className={Styles.relatedSearches}>
			<Link
				href={cityUrl}
				title={text}
				onClick={onClickHandler}
				className={Styles.cityLink}
			>
				<Icon
					className={Styles.searchIcon}
					name="search-expressive"
					size="sm"
					aria-label="Explore other vendors"
				/>
				<TextBody size="md" bold className={Styles.searchText}>
					{text}
				</TextBody>
				<Icon
					className={Styles.carretIcon}
					name="caret-right"
					size="sm"
					aria-label="Search"
				/>
			</Link>
		</div>
	);
};
